import { useState } from "react";
import { TwModal } from '@ui-component-library';
import VbTextarea from '@vb-js-commons/new/vbTextarea';
import Cookies from 'js-cookie';



const saveTranslations = (translated) => {
    let promises = []
    Object.keys(translated).forEach((key) => {
        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken'),
            'Content-Type': "application/json"
        }

        promises.push(fetch(`/lang-api/update-string/${Window.lang_data[key].id}/`, {
            method: "PATCH",
            headers: headers,
            body:JSON.stringify({
                result_txt: translated[key],
                requires_update: false
            })
        }));
    })

    Promise.all(promises).then(() => {
        window.location.reload();
    })
}



const TxtTranslateModal = (props) => {
    const [translated, setTranslated] = useState(Object.keys(Window.lang_data).reduce((acum, key) => {if(Window.lang_data[key].requires_update) {acum[key] = Window.lang_data[key].result_txt} return acum}, {}))


    let itms = [];
    Object.keys(Window.lang_data).forEach((key) => {
        if(!Window.lang_data[key].result_txt){
            itms.push(Window.lang_data[key])
        }
        else if(Window.lang_data[key].requires_update){
            itms.push(Window.lang_data[key])
        }
    })



    return <TwModal isOpen={true}>
        <TwModal.Content>
            <h3>Page is missing translations!</h3>
            <div style={{maxHeight:"500px", overflowY:"auto"}}>
            {itms.map((obj) => {
                return <div className="border-b border-t my-2">
                    <p className="mb-0">Source Text: <span className="italic">{obj.source_txt}</span></p>
                    <p className="mb-0">Context clue: <span className="italic">{obj.context_clue}</span></p>
                    <p className="mb-1">Translate to: <span className="italic">{obj.target_lang}</span></p>
                    <VbTextarea initial={obj.result_txt} onChange={(val) => {setTranslated({...translated, [obj.location_id]:val})}} height="300px" />
                </div>
            })}
            </div>
            <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border border-[#2a2e33] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5]" onClick={() => {saveTranslations(translated)}}>Save</button>
        </TwModal.Content>
    </TwModal>
}

export default TxtTranslateModal;


